

























































































































































































































import Table from '@/components/Table.vue'
import {
  cancelTopUp,
  generateTopUpInvoice,
  getTopUpAgentById,
  getTopUps,
  recheckTopUp,
  releaseTopUp,
  resendTopUp,
  revokeTopUp,
} from '@/api/Topup/topup.api'
import { TableHeader, Params } from '@/utils/interfaces'
import { AsYouType } from 'libphonenumber-js'
import TopUpFilter from '@/components/Services/TopUps/TopUpFilter.vue'
import ActionButton from '@/components/ActionButton.vue'
import { tableHandler } from '@/utils/mixins/tableHandler'
import { GetTopUpDTO, TopUpAgent } from '@/utils/interfaces/topup.interface'
import { chipClasses } from '@/utils/chipClasses.constant'
import TopUpDetails from '@/components/Services/TopUps/TopUpDetails.vue'
import HistoryDialog from '@/components/Services/TopUps/HistoryDialog.vue'
import { formatDate } from '@/utils/functions'
import mixins from 'vue-typed-mixins'
import { reportMixin } from '@/utils/mixins/reportMixin'
import ConfirmDialog from '@/components/ConfirmDialog.vue'
import TreeviewButton from '@/components/Services/TopUps/TreeviewButton.vue'
import { productsEnum } from '@/utils/productsCode.constant'
import CopyButton from '@/components/Services/TopUps/CopyButton.vue'
import PrintTopUpButton from '~/components/Services/TopUps/PrintTopUpButton.vue'
import FlatCard from '~/components/FlatCard.vue'
import FlatTable from '~/components/FlatTable.vue'
import TextButton from '~/components/TextButton.vue'

export default mixins(reportMixin, tableHandler<GetTopUpDTO>()).extend({
  components: {
    appTable: Table,
    appTopUpFilter: TopUpFilter,
    appActionButton: ActionButton,
    appTopUpDetails: TopUpDetails,
    appHistoryDialog: HistoryDialog,
    appConfirmDialog: ConfirmDialog,
    appTreeviewButton: TreeviewButton,
    CopyButton,
    PrintTopUpButton,
    FlatCard,
    FlatTable,
    TextButton,
  },
  data() {
    return {
      createDialogModel: false,
      historyDialog: false,
      key: 0,
      headers: [
        {
          text: this.$t('details'),
          value: 'details',
        },
        {
          text: this.$t('agency.agency'),
          value: 'from_agency_name',
          notShow: !this.$p.isAdmin,
        },
        {
          text: this.$t('client-name'),
          value: 'client',
        },
        {
          text: this.$t('number'),
          value: 'phone_number',
        },
        {
          text: this.$t('agent'),
          value: 'from_agent_name',
        },
        {
          text: this.$t('amount') + ' ($)',
          value: 'amount',
        },
        {
          text: this.$t('created-at'),
          value: 'created_at',
        },
        {
          text: this.$t('status'),
          value: 'status',
        },
      ] as TableHeader[],
      getter: (params?: Params) => {
        const newParams = {
          ...params,
          topup__product__code__in: `${productsEnum.TOPUP},${productsEnum.PACKAGE}`,
        }
        if (this.$store.getters.profile.role === 'ADMIN') {
          return getTopUps({
            integration: false,
            chain_type: 'AGENCY',
            ...newParams,
          })
        } else
          return getTopUps({
            ...newParams,
          })
      },
      chipClasses: chipClasses,
      historyItem: null as null | GetTopUpDTO,
      reviewItem: null as null | GetTopUpDTO,
      loadingReport: false,
      confirmDialog: false,
      loadingConfirm: false,
      loadingRefresh: false,
      loadingAgent: false,
      agent: {} as TopUpAgent,
      action: '',
      loadingInvoice: false,
    }
  },
  methods: {
    async onGenerateInvoice(value: boolean) {
      try {
        this.loadingInvoice = true
        const response = await generateTopUpInvoice({
          ...this.table.lastFilter,
          ['show-cost']: value,
        })
        const url = window.URL.createObjectURL(new Blob([response.data]))
        const link = document.createElement('a')
        link.href = url
        link.download = 'invoices.pdf'
        link.click()
      } finally {
        this.loadingInvoice = false
      }
    },
    onRefreshTree() {
      this.key++
      this.resolveAgent()
    },
    onDone(payload: boolean) {
      if (payload) {
        this.onSuccessReview()
      } else {
        this.onRejectReview()
      }
    },
    onReview(item: GetTopUpDTO, action: string) {
      this.action = action
      this.reviewItem = item
      this.confirmDialog = true
    },
    async onSuccessReview() {
      try {
        this.loadingConfirm = true
        if (this.reviewItem) {
          switch (this.reviewItem.status) {
            case 'Pending':
              await recheckTopUp(this.reviewItem.topup)
              break
            case 'Sent':
              if (this.action === 'resend') {
                await resendTopUp(this.reviewItem.topup)
              } else if (this.action === 'cancel') {
                await cancelTopUp(this.reviewItem.topup)
                this.reviewItem.status = 'Canceled'
              }
              break
            case 'Hold':
              if (this.action === 'release') {
                await releaseTopUp(this.reviewItem.topup)
                this.reviewItem.status = 'Sent'
              } else {
                await cancelTopUp(this.reviewItem.topup)
                this.reviewItem.status = 'Canceled'
              }
              break
            case 'Success':
              await revokeTopUp(this.reviewItem.topup)
              this.reviewItem.status = 'Revoked'
              break
            default:
              break
          }
        }
      } finally {
        this.loadingConfirm = false
        this.reviewItem = null
      }
    },
    onRejectReview() {
      this.reviewItem = null
    },
    async getReport() {
      try {
        this.loadingReport = true
        await this.generateReport(this.table.lastFilter)
      } finally {
        this.loadingReport = false
      }
    },
    formatDate(date: string): string {
      return formatDate(date)
    },
    asYouType(value: string) {
      return new AsYouType().input(value)
    },
    async refresh() {
      this.table.refresh()
    },
    onHistory(item: GetTopUpDTO) {
      this.historyItem = item
      this.historyDialog = true
    },
    resolveAgent() {
      this.loadingAgent = true
      getTopUpAgentById(this.$store.getters.profile.uuid)
        .then(response => {
          this.agent = response.data
        })
        .finally(() => {
          this.loadingAgent = false
        })
    },
  },
  created() {
    if (this.$store.getters.profile.role === 'ADMIN') {
      this.headers.splice(3, 0, {
        text: this.$t('provider'),
        value: 'provider',
      })
    }
    if (this.$store.getters.profile.is_superuser || this.$p.isMaikel) {
      this.headers.splice(4, 1, {
        text: this.$t('created_by'),
        value: 'created_by',
      })
      this.headers.push({
        text: this.$t('actions'),
        value: 'actions',
      })
    }
  },
  mounted() {
    if (!this.$p.isIntegration && !this.$p.isEmployee) {
      this.resolveAgent()
    }
  },
})
